export enum LocalStorageKeys {
  ACCEPTED_COOKIES = 'accepted-cookies',
}
